import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Turnstile from "react-turnstile";
import AuthCard from "./AuthCard";
import { Button, Input } from "../../components/ui";
import { authService } from "../../services/auth";
import { CAPTCHA, IS_MOCK } from "../../services/config";
import { useToast } from "../../context/ToastContext";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useToast();
  const [form, setForm] = useState({ email: "", password: "" });
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaKey, setCaptchaKey] = useState(Date.now());
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (key) => (e) => setForm((p) => ({ ...p, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.email || !form.password) return setError("กรุณากรอกอีเมลและรหัสผ่าน");
    if (CAPTCHA.siteKey && !captchaToken && !CAPTCHA.masterToken) return setError("กรุณายืนยันว่าคุณไม่ใช่บอท");
    setLoading(true);
    try {
      await authService.login({ ...form, captchaToken, remember: true });
      toast("เข้าสู่ระบบสำเร็จ", "success");
      navigate(location.state?.from || "/", { replace: true });
    } catch (err) {
      setError(err.message);
      setCaptchaToken("");
      setCaptchaKey(Date.now());
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard
      title="ยินดีต้อนรับกลับมา"
      subtitle="เข้าสู่ระบบเพื่อคุยกับตัวละครของคุณต่อ"
      footer={<>ยังไม่มีบัญชี? <Link to="/register">สร้างบัญชี</Link></>}
    >
      <form onSubmit={submit} noValidate>
        <Input label="อีเมล" type="email" placeholder="you@example.com" value={form.email} onChange={set("email")} autoComplete="username" />
        <Input label="รหัสผ่าน" type="password" placeholder="••••••••" value={form.password} onChange={set("password")} autoComplete="current-password" />
        {CAPTCHA.siteKey ? (
          <div className="mb-16">
            <Turnstile key={captchaKey} sitekey={CAPTCHA.siteKey} theme="dark" onVerify={setCaptchaToken} onExpire={() => setCaptchaToken("")} onError={() => setCaptchaToken("")} />
          </div>
        ) : null}
        {error ? <div className="error-text mb-8" role="alert">{error}</div> : null}
        <Button type="submit" variant="primary" block size="lg" disabled={loading}>{loading ? "กำลังเข้าสู่ระบบ..." : "เข้าสู่ระบบ"}</Button>
      </form>
      <div className="center mt-16" style={{ fontSize: 14 }}><Link to="/forgot">ลืมรหัสผ่าน?</Link></div>
      {IS_MOCK ? <p className="faint center mt-16" style={{ fontSize: 12 }}>โหมดทดลอง (ข้อมูลอยู่ในเบราว์เซอร์เท่านั้น) — สมัครด้วยอีเมลอะไรก็ได้</p> : null}
    </AuthCard>
  );
}
